import { defineMessage } from 'services/localization';

export const messages = {
    oneDocumentPerFileButtonTitle: defineMessage('one_document_per_file'),
    oneDocumentPerFileDescription: defineMessage('each_uploaded_file_is_a_separate_document'),
    oneDocumentPerPageButtonTitle: defineMessage('one_document_per_page'),
    oneDocumentPerPageButtonDescription: defineMessage('each_page_in_the_upload__is_a_separate_document'),
    fileToUploadButtonSectionTitle: defineMessage('file_type_to_upload'),
};
